<div class="my-3 my-md-5">
    <div class="container-fluid">
        <div class="col-sm-6 float-left">
            <h1 class="page-title">Complaints</h1>
        </div>
    </div>
    <div class="card">
        <form [formGroup]="userInformation">
            <div class="card-body patientDetailbox">
                <div class="container-fluid p-3">
                    <h3><strong>Patient Information</strong></h3>
                    <div class="form-group">
                        <div class="row">
                            <div class="col-sm-4">
                                <div class="form-group">
                                    <label class="form-label">Patient Name</label>
                                    <input class="form-control readonly" formControlName="pname"
                                        placeholder="Patient Name" readonly />
                                </div>
                            </div>
                            <div class="col-sm-4">
                                <div class="form-group">
                                    <label class="form-label">Treatment</label>
                                    <input class="form-control readonly" formControlName="treatment"
                                        placeholder="Treatment" readonly />
                                </div>
                            </div>
                            <div class="col-sm-4">
                                <div class="form-group">
                                    <label class="form-label">Doctor Name</label>
                                    <input class="form-control readonly" formControlName="docname"
                                        placeholder="Doctor Name" readonly />
                                </div>
                            </div>
                            <div class="col-sm-4">
                                <div class="form-group">
                                    <label class="form-label">Hospital Name</label>
                                    <input class="form-control readonly" formControlName="hospitalname"
                                        placeholder="Hospital Name" readonly />
                                </div>
                            </div>
                            <div class="col-sm-4">
                                <div class="form-group">
                                    <label class="form-label">Lead Owner Name</label>
                                    <input class="form-control readonly" formControlName="bd_name"
                                        placeholder="Lead Owner Name" readonly />
                                </div>
                            </div>
                            
                           
                           
                        </div>
                        <div class="row">
                            <div class="col-sm-6">
                                <div class="form-group">
                                    <label class="form-label">Feedback Description</label>
                                    <textarea class="form-control" formControlName="description" readonly></textarea>
                                </div>
                            </div>

                            <div class="col-sm-6">
                                <div class="form-group">
                                    <label class="form-label"> Complaint Description</label>
                                    <textarea class="form-control" formControlName="complaint_description" readonly></textarea>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>

    <div class="container-fluid px-4 pt-4 card">

        <div class="card">
            <form [formGroup]="complaintForm" (submit)="addComplaintAction()">
                <div *ngIf="bdComplaintList[0]!='' && (myrole=='1' || myrole=='3' || (myrole=='4' && (currentUserId=='19' || currentUserId=='67'|| currentUserId=='66' || currentUserId=='112' || currentUserId=='49' || currentUserId=='123' || currentUserId=='204' || currentUserId=='413' || currentUserId=='420' || currentUserId=='337')))" class="card-body patientDetailbox">
                    <div class="container-fluid p-3">
                        <div class="form-group">
                            <div class="row">
                                <div class="col-sm-6">
                                    <h3><strong>BD (Medical Coordinator) Complaints</strong></h3>
                                    <div *ngFor="let complaint of bdComplaintList;let index = index;">
                                        <h4>{{index+1}} - {{complaint}}</h4>
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label class="form-label">Conclusion</label>
                                        <textarea formControlName="bd_description" class="form-control"
                                            id="exampleFormControlTextarea1" rows="3"></textarea>
                                    </div>
                                    <div class="form-group">
                                        <label class="form-label">Status</label>
                                        <mat-select formControlName="bd_comp_status" placeholder="Status">
                                            <mat-option [value]="3">Pending</mat-option>
                                            <mat-option [value]="2">Completed</mat-option>
                                        </mat-select>
                                    </div>

                                    <div class="form-group" *ngIf="bd_action_time != null">
                                      <span>{{bd_action_time*1000|date:'dd MMM YYYY , h:mm a'}}</span>
                                    </div>
                                    
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div *ngIf="doctorComplaintList[0]!='' && (myrole=='1' || (myrole=='4' && (currentUserId=='19' || currentUserId=='67'|| currentUserId=='66' || currentUserId=='112' || currentUserId=='49' || currentUserId=='123' || currentUserId=='204' || currentUserId=='413' || currentUserId=='420' || currentUserId=='337' || currentUserId=='177' || currentUserId=='180' || currentUserId=='140' || currentUserId=='62')))" class="card-body patientDetailbox">
                    <div class="container-fluid p-3">
                        <div class="form-group">
                            <div class="row">
                                <div class="col-sm-6">
                                    <h3><strong>Doctor Complaints</strong></h3>
                                    <div *ngFor="let complaint of doctorComplaintList;let index = index;">
                                        <h4>{{index+1}} - {{complaint}}</h4>
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label class="form-label">Conclusion</label>
                                        <textarea formControlName="doctor_description" class="form-control"
                                            id="exampleFormControlTextarea1" rows="3"></textarea>
                                    </div>
                                    <div class="form-group">
                                        <label class="form-label">Status</label>
                                        <mat-select formControlName="doctor_comp_status" placeholder="Status">
                                            <mat-option [value]="3">Pending</mat-option>
                                            <mat-option [value]="2">Completed</mat-option>
                                        </mat-select>
                                    </div>

                                    <div class="form-group" *ngIf="doctor_action_time != null">
                                        <span>{{doctor_action_time*1000|date:'dd MMM YYYY , h:mm a'}}</span>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div *ngIf="hInfrastructureComplaintList[0]!='' && (myrole=='1' || myrole=='10' || (myrole=='8' && (currentUserId=='144' || currentUserId=='250' || currentUserId=='433'))  || (myrole=='4' && (currentUserId=='19' || currentUserId=='67'|| currentUserId=='66' || currentUserId=='112' || currentUserId=='49' || currentUserId=='123' || currentUserId=='204' || currentUserId=='413' || currentUserId=='420' || currentUserId=='337')))" class="card-body patientDetailbox">
                    <div class="container-fluid p-3">
                        <div class="form-group">
                            <div class="row">
                                <div class="col-sm-6">
                                    <h3><strong>Hospital Infrastructure Complaints</strong></h3>
                                    <div *ngFor="let complaint of hInfrastructureComplaintList;let index = index;">
                                        <h4>{{index+1}} - {{complaint}}</h4>
                                    </div>


                                    <div *ngIf="hospital_infrastructure_comp_doc != null ">
                                        <h4><strong>Complaint Document</strong></h4>
                                        <div class="col text-truncate">
                                            <a  href="{{s3url}}{{hospital_infrastructure_comp_doc}}" target="_blank" class="text-body d-block">View File</a>
                                            <small class="d-block text-muted text-truncate mt-n1">{{hospital_infrastructure_comp_doc}}</small>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label class="form-label">Conclusion</label>
                                        <textarea formControlName="hospital_infrastructure_description"
                                            class="form-control" id="exampleFormControlTextarea1" rows="3"></textarea>
                                    </div>
                                    
                                    <div class="form-group">
                                        <label class="form-label">Upload Hospital Infrastructure Complaint Document</label>
                                        <input type="file" class="form-control" (change)="selectDocument($event)" />
                                    </div>
                                    
                                    <div class="form-group">
                                        <label class="form-label">Status</label>
                                        <mat-select formControlName="hospital_infrastructure_comp_status"
                                            placeholder="Status">
                                            <mat-option [value]="3">Pending</mat-option>
                                            <mat-option [value]="2">Completed</mat-option>
                                        </mat-select>
                                    </div>

                                    <div class="form-group" *ngIf="hospital_infrastructure_action_time != null">
                                        <span>{{hospital_infrastructure_action_time*1000|date:'dd MMM YYYY , h:mm a'}}</span>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div *ngIf="hStaffComplaintList[0]!='' && (myrole=='1' || myrole=='10' || (myrole=='8' && (currentUserId=='433')) || (myrole=='4' && (currentUserId=='19' || currentUserId=='67'|| currentUserId=='66' || currentUserId=='112' || currentUserId=='49' || currentUserId=='123' || currentUserId=='204' || currentUserId=='413' || currentUserId=='420' || currentUserId=='337')))" class="card-body patientDetailbox">
                    <div class="container-fluid p-3">
                        <div class="form-group">
                            <div class="row">
                                <div class="col-sm-6">
                                    <h3><strong>Hospital Staff Complaints</strong></h3>
                                    <div *ngFor="let complaint of hStaffComplaintList;let index = index;">
                                        <h4>{{index+1}} - {{complaint}}</h4>
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label class="form-label">Conclusion</label>
                                        <textarea formControlName="hospital_staff_description" class="form-control"
                                            id="exampleFormControlTextarea1" rows="3"></textarea>
                                    </div>
                                    <div class="form-group">
                                        <label class="form-label">Status</label>
                                        <mat-select formControlName="hospital_staff_comp_status" placeholder="Status">
                                            <mat-option [value]="3">Pending</mat-option>
                                            <mat-option [value]="2">Completed</mat-option>
                                        </mat-select>
                                    </div>

                                    <div class="form-group" *ngIf="hospital_staff_action_time != null">
                                        <span>{{hospital_staff_action_time*1000|date:'dd MMM YYYY , h:mm a'}}</span>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div *ngIf="admissionComplaintList[0]!='' && ( myrole=='1' || (myrole=='8' && (currentUserId=='114' || currentUserId=='250')) || (myrole=='4' && (currentUserId=='19' || currentUserId=='67'|| currentUserId=='66' || currentUserId=='112' || currentUserId=='49' || currentUserId=='123' || currentUserId=='204' || currentUserId=='413' || currentUserId=='420' || currentUserId=='337')))" class="card-body patientDetailbox">
                    <div class="container-fluid p-3">
                        <div class="form-group">
                            <div class="row">
                                <div class="col-sm-6">
                                    <h3><strong>Admission Complaints</strong></h3>
                                    <div *ngFor="let complaint of admissionComplaintList;let index = index;">
                                        <h4>{{index+1}} - {{complaint}}</h4>
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label class="form-label">Conclusion</label>
                                        <textarea formControlName="admission_description" class="form-control"
                                            id="exampleFormControlTextarea1" rows="3"></textarea>
                                    </div>
                                    <div class="form-group">
                                        <label class="form-label">Status</label>
                                        <mat-select formControlName="admission_comp_status" placeholder="Status">
                                            <mat-option [value]="3">Pending</mat-option>
                                            <mat-option [value]="2">Completed</mat-option>
                                        </mat-select>
                                    </div>

                                    <div class="form-group" *ngIf="admission_action_time != null">
                                        <span>{{admission_action_time*1000|date:'dd MMM YYYY , h:mm a'}}</span>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div *ngIf="dischargeComplaintList[0]!='' && (myrole=='1' || (myrole=='8' && (currentUserId=='114' || currentUserId=='250')) || (myrole=='4' && (currentUserId=='19' || currentUserId=='67'|| currentUserId=='66' || currentUserId=='112' || currentUserId=='49' || currentUserId=='123' || currentUserId=='204' || currentUserId=='413' || currentUserId=='420' || currentUserId=='337')))" class="card-body patientDetailbox">
                    <div class="container-fluid p-3">
                        <div class="form-group">
                            <div class="row">
                                <div class="col-sm-6">
                                    <h3><strong>Discharge Complaints</strong></h3>
                                    <div *ngFor="let complaint of dischargeComplaintList;let index = index;">
                                        <h4>{{index+1}} - {{complaint}}</h4>
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label class="form-label">Conclusion</label>
                                        <textarea formControlName="discharge_description" class="form-control"
                                            id="exampleFormControlTextarea1" rows="3"></textarea>
                                    </div>
                                    <div class="form-group">
                                        <label class="form-label">Status</label>
                                        <mat-select formControlName="discharge_comp_status" placeholder="Status">
                                            <mat-option [value]="3">Pending</mat-option>
                                            <mat-option [value]="2">Completed</mat-option>
                                        </mat-select>
                                    </div>

                                    <div class="form-group" *ngIf="discharge_action_time != null">
                                        <span>{{discharge_action_time*1000|date:'dd MMM YYYY , h:mm a'}}</span>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div *ngIf="otherComplaintList[0]!='' && (myrole=='1' || (myrole=='4' && (currentUserId=='19' || currentUserId=='67'|| currentUserId=='66' || currentUserId=='112' || currentUserId=='49' || currentUserId=='123' || currentUserId=='204' || currentUserId=='413' || currentUserId=='420' || currentUserId=='337')))" class="card-body patientDetailbox">
                    <div class="container-fluid p-3">
                        <div class="form-group">
                            <div class="row">
                                <div class="col-sm-6">
                                    <h3><strong>Others Complaints</strong></h3>
                                    <div *ngFor="let complaint of otherComplaintList;let index = index;">
                                        <h4>{{index+1}} - {{complaint}}</h4>
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label class="form-label">Conclusion</label>
                                        <textarea formControlName="others_description" class="form-control"
                                            id="exampleFormControlTextarea1" rows="3"></textarea>
                                    </div>
                                    <div class="form-group">
                                        <label class="form-label">Status</label>
                                        <mat-select formControlName="others_comp_status" placeholder="Status">
                                            <mat-option [value]="3">Pending</mat-option>
                                            <mat-option [value]="2">Completed</mat-option>
                                        </mat-select>
                                    </div>

                                    <div class="form-group" *ngIf="others_action_time != null">
                                        <span>{{others_action_time*1000|date:'dd MMM YYYY , h:mm a'}}</span>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div *ngIf="myrole=='1' || (myrole=='4' && (currentUserId=='19' || currentUserId=='67'|| currentUserId=='66' || currentUserId=='112' || currentUserId=='49' || currentUserId=='123' || currentUserId=='204' || currentUserId=='413' || currentUserId=='420' || currentUserId=='337'))" class="card-body patientDetailbox">
                    <div class="container-fluid p-3">
                        <div class="form-group">
                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label class="form-label">Final Conclusion</label>
                                        <textarea formControlName="final_description" class="form-control"
                                            id="exampleFormControlTextarea1" rows="3"></textarea>
                                    </div>

                                    <div class="form-group">
                                        <label class="form-label">Status</label>
                                        <mat-select formControlName="final_status" placeholder="Status">
                                            <mat-option [value]="1">Pending</mat-option>
                                            <mat-option [value]="2">Completed</mat-option>
                                        </mat-select>
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                   
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="card-footer">
                    <button type="submit" [disabled]="loading" class="btn btn-primary"><i *ngIf="loading"
                            class="fa fa-spin fa-spinner"></i>
                        <span>Submit</span>
                    </button>
                </div>

            </form>
        </div>
    </div>